/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Maturity_PrInputs */

const en_fc_cmp_maturity_pr = /** @type {(inputs: Fc_Cmp_Maturity_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry standard since 2003`)
};

/**
* | output |
* | --- |
* | "Industry standard since 2003" |
*
* @param {Fc_Cmp_Maturity_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_maturity_pr = /** @type {((inputs?: Fc_Cmp_Maturity_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Maturity_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_maturity_pr(inputs)
});
export { fc_cmp_maturity_pr as "fc.cmp.maturity.pr" }